import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import SuccessModal from "../components/SuccessModal";
import "./WigDetail.css";
import { apiFetch } from "../utils/api";

export default function WigDetail() {
  const { id } = useParams();
  const [wig, setWig] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({
    customerName: "",
    phone: "",
    address: "",
    consent: false,
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    apiFetch(`/api/wigs/${id}`)
      .then((r) => r.json())
      .then((data) => setWig(data));
  }, [id]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await apiFetch("/api/orders", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ wigId: id, ...formData }),
      });
      setShowModal(true);
      setFormData({ customerName: "", phone: "", address: "", consent: false });
    } catch (err) {
      alert("Failed to submit, please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  if (!wig) return <p>Loading…</p>;

  return (
    <div className="detail">
      <h1>{wig.name}</h1>
      <div className="gallery">
        {wig.images.map((src, i) => (
          <img key={i} src={src} alt={`${wig.name} ${i + 1}`} />
        ))}
      </div>
      <p>{wig.description}</p>
      <p className="price">₹{wig.price}</p>

      <form className="order-form" onSubmit={handleSubmit}>
        <h2>Order this wig</h2>
        <label>
          Name:
          <br />
          <input
            name="customerName"
            value={formData.customerName}
            onChange={handleChange}
            required
            disabled={loading}
          />
        </label>
        <label>
          Phone:
          <br />
          <input
            name="phone"
            value={formData.phone}
            onChange={handleChange}
            required
            disabled={loading}
          />
        </label>
        <label>
          Address:
          <br />
          <textarea
            name="address"
            value={formData.address}
            onChange={handleChange}
            required
            disabled={loading}
          />
        </label>
        <label className="consent">
          <input
            type="checkbox"
            name="consent"
            checked={formData.consent}
            onChange={handleChange}
            required
            disabled={loading}
          />{" "}
          I consent to having my details stored in accordance with the privacy
          policy.
        </label>
        <button type="submit" disabled={loading}>
          {loading ? "Submitting..." : "Submit"}
        </button>
      </form>

      <SuccessModal isOpen={showModal} onClose={handleCloseModal} />
    </div>
  );
}
